interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "BHD";
};

const BHD: Currency = Object.freeze({
  "displayName": "Bahraini Dinar",
  "numericCode": 48,
  "defaultFractionDigits": 3,
  "subUnit": 1000,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "BHD",
  "symbol": ".د.ب"
});

export { BHD };
